import type { ReactNode } from 'react';
import Assembly from '../Modular/Assembly';
import Unit from '../Modular/Unit';
import type { AssemblySettings } from '../Modular/ModularTypes/AssemblySettings';
import type { UnitSettings } from '../Modular/ModularTypes/UnitSettings';
import './Form.css';

export type FormVariant = 'stacked';

export type FormProps = {
  children: ReactNode;
  variant?: FormVariant;
  className?: string;
} & Omit<AssemblySettings<'form'>, 'as' | 'children' | 'className'>;

const Form = ({
  children,
  variant = 'stacked',
  className = '',
  ...props
}: FormProps) => (
  <Assembly
    {...props}
    as="form"
    className={`form-base form-${variant} ${className}`.trim()}
  >
    {children}
  </Assembly>
);

export type FormFeedbackProps = {
  children: ReactNode;
  variant?: 'error';
} & Omit<UnitSettings<'div'>, 'as' | 'children' | 'className'>;

export const FormFeedback = ({
  children,
  variant = 'error',
  ...props
}: FormFeedbackProps) => (
  <Unit
    {...props}
    as="div"
    className={`form-feedback form-feedback-${variant}`}
  >
    {children}
  </Unit>
);

export default Form;
